import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';
import { LuLoader2 } from 'react-icons/lu';

import { DASHBOARD_ROUTE } from '../../../config';
import { useReportContext } from '../../../providers/ReportContext';
import { formatarDuracao, resumirProgresso } from '../../../features/dashboard/components/ProgressoRelatorio';

/**
 * Progresso do relatorio no cabecalho: porcentagem (barra dentro do botao),
 * etapas feitas sobre o total e tempo decorrido. E o que deixa acompanhar a
 * geracao de qualquer tela do site. Clicar leva ao Dashboard, onde fica a lista
 * completa das etapas.
 *
 * Componente proprio para o relogio de 1 s redesenhar so ele, e nao o cabecalho.
 */
export function ProgressoNoCabecalho() {
    const { job } = useReportContext();
    const navigate = useNavigate();
    const [agora, setAgora] = useState(Date.now());

    useEffect(() => {
        const id = window.setInterval(() => setAgora(Date.now()), 1000);
        return () => window.clearInterval(id);
    }, []);

    const { concluidas, total, percentual, atual, terminou } = resumirProgresso(job?.etapas ?? [], job?.tipo, job?.concluido);

    // Antes de o tipo chegar nao ha total previsto: mostra so o tempo.
    const temTotal = Boolean(job?.tipo) && total > 1;
    const tempo = job?.iniciadoEm ? formatarDuracao(agora - job.iniciadoEm) : '--:--';

    const dica = terminou
        ? 'Relatório concluído. Organizando os dados…'
        : job?.status === 'queued' || !atual
            ? 'Preparando o ambiente de execução…'
            : `Etapa atual: ${atual}`;

    return (
        <Tooltip title={<>{dica}<br />Clique para ver todas as etapas.</>} placement="bottomRight">
            <button
                type="button"
                className="header-gerando"
                onClick={() => navigate(DASHBOARD_ROUTE)}
                aria-label={`Gerando relatório: ${percentual}% concluído, ${tempo} decorridos`}
            >
                <LuLoader2 className="header-gerando-icone" aria-hidden="true" />
                <span className="header-gerando-texto">
                    {job?.tipo === 'Rem' ? 'Gerando remarcação' : 'Gerando relatório'}
                </span>
                {temTotal && <span className="header-gerando-etapas">{Math.min(concluidas, total)}/{total}</span>}
                <span className="header-gerando-tempo">{tempo}</span>
                <span className="header-gerando-barra" aria-hidden="true">
                    <span style={{ width: `${temTotal ? percentual : 0}%` }} />
                </span>
            </button>
        </Tooltip>
    );
}
